var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 1.5v5h5v-5h-5ZM1 0a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1Zm15.5 16.5v-5h-5v5h5ZM17 18a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    d: "M14.78 7.53a.75.75 0 1 1-1.06-1.06l1.72-1.72h-5.19a.75.75 0 0 1 0-1.5h5.19l-1.72-1.72A.75.75 0 0 1 14.78.47l3 3a.747.747 0 0 1 0 1.06l-3 3Zm-11.56 10a.75.75 0 0 0 1.06-1.06l-1.72-1.72h5.19a.75.75 0 0 0 0-1.5H2.56l1.72-1.72a.75.75 0 1 0-1.06-1.06l-3 3a.748.748 0 0 0 0 1.06l3 3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.b493bad09796b1c62bd80f22d5742a50.svg";
export { ForwardRef as ReactComponent };